import { useAppSelector } from "@/Hook/hooks";
import classNames from "classnames";
import { Container, Nav, Navbar } from "react-bootstrap";
import ActiveApproval from "./ActiveApproval";
import CompanySelector from "./CompanySelector";
import LanguageSelector from './LanguageSelector';
import Search from "./Search";
import UserDropdown from "./UserDropdown";

const Header = () => {
	const sideBarState = useAppSelector((state) => state.Home.sideBarState);

	return (
		<>
			<div>
				<Navbar bg="white" expand={true} className={classNames(["header", { unpinned: sideBarState == "unpinned" }])}>
					<Container fluid
						className="px-0 h-100"
					>
						<Nav id="user-nav" className="ms-auto">
							<CompanySelector />
							<Search />

							<LanguageSelector />

							<ActiveApproval />
							<UserDropdown />
						</Nav>
					</Container>
				</Navbar >
			</div>
		</>
	);
};

export default Header;
